<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button v-if="questionId != 0" class="pull-right btn btn-info deleteMedia mr-1 " type="button" v-on:click.prevent="backButton()">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="forumCommentList"
                        mode="remote"
                        title="Forum Question List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteComment()">Delete Comment({{selectedRows}})</button>
                        </div>

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'question'">
                                    <span>{{props.row.question}}</span>
                                </div>
                                <div v-else-if="props.column.field == 'action'">
                                    <a class="btn edit-btn-vvg waves-effect" title='View Question Comment' v-on:click.prevent="viewCommentDetailPage(props.row.id)">
                                        <i class="fa fa-eye" aria-hidden="true"></i>
                                    </a>
                                    <!-- <template v-if="props.row.status == 'Not-Approved'">
                                        <button title='Approve Question' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="changeCommentStatus(props.row.id)"><i class="fa fa-check" aria-hidden="true"></i></button>
                                        <button title='Decline Question' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteComment(props.row.id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                    </template>
                                    <template v-else> -->
                                        <!--<router-link title='View Question Details' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'UpdateEvent',params:{id:props.row.id}}"><i class="fa fa-eye" aria-hidden="true"></i></router-link>-->
                                        <a class="btn edit-btn-vvg waves-effect" title='Delete Question' id="delete" v-on:click.prevent="deleteComment(props.row.id)">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                    <!-- </template> -->
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListForumQuestions',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                error: '',
                exportUsers: false,
                modelTitle: '',
                modelButtonId: '',
                subject: '',
                subjectError: '',
                message: '',
                messageError: '',
                filesAttachment: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Comment',
                        field: 'comment',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Comment", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created By',
                        field: 'created_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        width: '158px',
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
                questionId: 0,
                pageTitle: "Forum Comment List",
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        watch: {
            /* '$route': function(to, from) {
                self.$nextTick(function () {
                    if (typeof (self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                        self.questionId = self.$route.params.id;
                    } else {
                        self.questionId = 0;
                    }
                    if (self.questionId > 0) {
                        self.getQuestion();
                    } else {
                        self.loadComments();
                    }
                    console.log(self.questionId);
                });
            },
            questionId: function (questionId) {
                if (self.questionId > 0) {
                    self.getQuestion();
                } else {
                    self.pageTitle = "Forum Comment List";
                    self.loadComments();
                }
            }, */
        },
        mounted: function () {
            self.showLoader();
            if (typeof (self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.questionId = self.$route.params.id;
            } else {
                self.questionId = 0;
            }
            if (self.questionId > 0) {
                self.getQuestion();
            } else {
                self.pageTitle = "Forum Comment List";
                self.loadComments();
            }
        },
        methods: {
            backButton: function () {
                var route = '/backend/forum-posts';
                self.$router.push(route);
            },
            viewCommentDetailPage(id) {
                var route = '/backend/forum-comment-details/' + id;
                if (self.questionId > 0) {
                    route += '/' + self.questionId;
                }
                self.$router.push(route);
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadComments();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadComments();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('answer_id');
                    field: ('comment');
                    field: ('is_active');
                    field: ('status');
                    field: ('created_by');
                    field: ('approved_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id == 1 || filters.answer_id || filters.comment || filters.is_active || filters.status || filters.created_by || filters.approved_by) {
                    self.loadComments();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['forumCommentList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadComments();
            },
            getQuestion() {
                if (self.questionId > 0) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var fields = {
                        question_id: self.questionId,
                    };
                    self.showLoader();
                    HTTP.post("getcommentquestion", fields, config)
                            .then(function (response) {
                                self.hideLoader();
                                if (response.data.code == 200) {
                                    self.pageTitle = response.data.content.question + " Comment(s)";
                                    self.loadComments();
                                }
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    self.error = err.response.data.message;
                                }
                                self.hideLoader();
                            });
                }

            },
            loadComments: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    question_id: self.questionId
                };
                self.showLoader();
                HTTP.post('listcomments', fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        }
                        self.exportUsers = false;
                        self.hideLoader();
                    })
            },
            deleteComment: function (id) {
                var questionArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                if (id) {
                    questionArr.push(id);
                } else {
                    var selectedQuestion = self.$refs['forumCommentList'].selectedRows;
                    for (var i = 0; i < selectedQuestion.length; i++) {
                        questionArr.push(this.$refs['forumCommentList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: questionArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deletecomments", fields, config)
                                .then(function (response) {
                                    self.loadComments();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal({
                            title: 'Deleted',
                            type: 'success',
                            text: 'You successfully deleted the record(s).',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/forum/ListForumComments.vue